export default function BDFlag() {
  return (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_685_13423"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="35"
        height="24"
      >
        <rect width="35" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_685_13423)">
        <rect width="35" height="24" fill="#38A17E" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8828 19C18.1112 19 21.5391 15.866 21.5391 12C21.5391 8.13401 18.1112 5 13.8828 5C9.65438 5 6.22656 8.13401 6.22656 12C6.22656 15.866 9.65438 19 13.8828 19Z"
          fill="#F72E45"
        />
      </g>
    </svg>
  );
}
